import { Group, Text, Button, Flex, Container, Card, Input, Select } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useState, useEffect } from 'react';
import { useDocumentTitle } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { useNavigate, useLocation } from "react-router-dom";
import { VisiLoader, HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import { UniversalSmartCodeModal } from "../../components/Settings/ManageYourDomains/UniversalSmartCodeModal";
import InsightsApi from "../../api/InsightsApi";

export function CreateHeatmap() {
  useDocumentTitle("Visiopt - Insights");
  const navigate = useNavigate();
  const location = useLocation();
  const HeatmapId = location.state?.heat_map_id;
  const [editedHeatmapId, setEditedHeatmapId] = useState(HeatmapId);
  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  const [heatMapName, setHeatMapName] = useState('');
  const [selectedFunnel, setSelectedFunnel] = useState('');
  const [selectedPage, setSelectedPage] = useState('');
  const [funnelList, setFunnelList] = useState([]);
  const [pageList, setPageList] = useState([]);
  const [isVisismartHeatmapCodeModalOpen, setIsVisismartHeatmapCodeModalOpen] = useState(false);
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);

  const handleHeaderMenuComponentChange = (Value:any) => {
    setSelectedMemberWebsite(Value);
  };

  const fetchFunnelList = () => {
    if(selectedMemberWebsite !== '') {
      setIsVisiLoaderVisible(true);
      InsightsApi.getfunnellist({
        system_website_id: selectedMemberWebsite
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setFunnelList(data.data);
        }
        setIsVisiLoaderVisible(false);
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }    
  };

  const fetchPageList = (Value:any) => {
    if(Value !== '') {
      setIsVisiLoaderVisible(true);
      InsightsApi.getpagelistbyfunnelid({
        funnel_id: Value
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setPageList(data.data);
          setIsVisiLoaderVisible(false);
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }    
  };

  const handleSelectedFunnel = (Value:any) => {
    setSelectedFunnel(Value);
    fetchPageList(Value);
  };

  const handleSelectedPage = (value:any) => {
    setSelectedPage(value);
    if(value !== '') {
      InsightsApi.heatmappagecheck({
        heatmap_page_id: value
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 0){
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          setSelectedPage('');
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      });
    }
  };

  const handleSaveHeatMap = (value:any) => {
    let dataObject = {};
    if(value === 'save') {
      dataObject = {
        heatmap_name: heatMapName,
        system_website_id: selectedMemberWebsite,
        funnel_id: selectedFunnel,
        page_id: selectedPage
      };
    }else if(value === 'update') {
      dataObject = {
        heatmap_name: heatMapName,
        system_website_id: selectedMemberWebsite,
        heatmap_id: editedHeatmapId,
        page_id: selectedPage
      };
    }
    setIsVisiLoaderVisible(true);
    InsightsApi.saveupdateheatmap(dataObject)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1) {
          setIsVisiLoaderVisible(false);
          if(data.data.smart_script_exits === 'no'){
            setIsVisismartHeatmapCodeModalOpen(true);
          }
          if(data.data.smart_script_exits === 'yes'){
            navigate('/heat-maps');
          }
        }else{
          setIsVisiLoaderVisible(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
  };

  const handleCancel = () => {
    navigate('/heat-maps');
    setEditedHeatmapId('');
    setHeatMapName('');
    setSelectedFunnel('');
    setSelectedPage('');
  };

  const onVisismartHeatmapCodeClose = () => {
    setIsVisismartHeatmapCodeModalOpen(false);
    navigate('/heat-maps');
  };

  useEffect(() => {
    fetchFunnelList();
  }, [selectedMemberWebsite]);

  useEffect(() => {
    if(editedHeatmapId && editedHeatmapId !== '') {
      setIsVisiLoaderVisible(true);
      InsightsApi.getsingleheatmapdetail({
        heatmap_id: editedHeatmapId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1) {
          setHeatMapName(data.data.heatmap_name);
          setSelectedFunnel(data.data.funnel_id);
          fetchPageList(data.data.funnel_id);
          setSelectedPage(data.data.page_id);
          setIsVisiLoaderVisible(false);
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          setIsVisiLoaderVisible(false);
        }        
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }
  }, [editedHeatmapId]);


	return (
		<>
      <VisiLoader VisiLoaderVisible={isVisiLoaderVisible}/>
      {/*START HELP ICON MODEL*/}
      {/*END HELP ICON MODEL*/}
      {/*START VISISMARTCODE MODAL*/}
      <UniversalSmartCodeModal
        opened={isVisismartHeatmapCodeModalOpen}
        onClose={onVisismartHeatmapCodeClose}
        websiteId={selectedMemberWebsite}
        websiteUrl={''}
        subdomainVisiSmartCode={false}
        visiSmartCodeSubdomainId={''}
        showAdvancedTracking={false}
        pageId={selectedPage}
      />
      {/*END VISISMARTCODE MODAL*/}
      <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
      <Container size="xl">
        <Card shadow="sm" padding="sm" radius="md" withBorder>
          <Group position="apart" mb="xs">
            <Text weight={500}>HEAT MAPS <HelpTip helpId={251} /></Text>
          </Group>
          <Flex
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Text w={130} mt={3}>Heat Map Name:</Text>
            <Input 
              w={250} 
              ml={0}
              mt={5}
              value={heatMapName} 
              onChange={(e) => setHeatMapName(e.target.value)} 
            />
          </Flex>
          <Flex
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Text w={130} mt={3}>Select Funnel:</Text>
            <Select
              data={[
                { value: '', label: 'Select Funnel', disabled: true }, 
                ...funnelList.map((funnel, index) => ({
                  value: funnel.funnel_id,
                  label: funnel.funnel_name
                }))
              ]}
              mt={5}
              dropdownPosition="bottom"
              withinPortal 
              value={selectedFunnel}
              onChange={handleSelectedFunnel}
              w={250}
              disabled={!!editedHeatmapId}
            />
          </Flex>
          <Flex
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Text w={130} mt={3}>Select Page:</Text>
            <Select
              data={[
                { value: '', label: 'Select Page', disabled: true }, 
                ...pageList.map((page, index) => ({
                  value: page.page_id,
                  label: page.page_name
                }))
              ]}
              mt={5}
              dropdownPosition="bottom"
              withinPortal 
              value={selectedPage}
              onChange={handleSelectedPage}
              w={250}
              disabled={!!editedHeatmapId}
            />
          </Flex>
          <Flex
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            {editedHeatmapId && editedHeatmapId !== '' ? (
                <Button size="sm" w={100} mt={10} ml={5} onClick={() => handleSaveHeatMap('update')}>Update</Button>
              ) : (
                <Button size="sm" w={70} mt={10} ml={5} onClick={() => handleSaveHeatMap('save')}>Save</Button>
            )}
            <Button size="sm" w={80} color="red" mt={10} ml={5} onClick={handleCancel}>
               Cancel
            </Button>
          </Flex>
        </Card>
      </Container>
		</>
	);
}